module.exports = __webpack_public_path__ + "img/unit1-structural.f3b62380.svg";